module.exports = __webpack_public_path__ + "static/bar01_2-b18c4d6a46e4ff1f6ceae436e4337fe4.png";